import { put, takeEvery, call } from 'redux-saga/effects'
import cookie from 'react-cookie'
import {
  INIT_APP_PARAMS,
  APP_PARAMS_INITIALIZED,
  APP_PARAMS_ERROR,
  SEND_WINDOW_INFO,
  BACK_POST_MESSAGE,
} from '../actions/index'
import sendPostMessage from '../services/post-communication'

function* onAppInit(action) {
  const { payload } = action
  if (!payload.site && !cookie.load('site')) {
    yield put({
      type: APP_PARAMS_ERROR,
      payload: {
        message: 'ERROR_MISSING_SITE_PARAMETER',
      },
    })
  } else {
    cookie.save('site', payload.site || cookie.load('site'), { maxAge: 600 })

    yield put({
      type: APP_PARAMS_INITIALIZED,
      payload: {
        site: payload.site || cookie.load('site'),
        locale: payload.locale || null,
      },
    })
  }
}

function* onWindowInfo(action) {
  const { payload } = action
  yield call(sendPostMessage, {
    ...payload,
    messageType: 'windowInfo'
  })
}

function* onBackAcceptAll(action) {
  const { payload } = action
  yield call(sendPostMessage, {
    ...payload,
    messageType: 'backAcceptAll'
  })
}

export default function* initApp() {
  yield takeEvery(INIT_APP_PARAMS, onAppInit)
  yield takeEvery(SEND_WINDOW_INFO, onWindowInfo)
  yield takeEvery(BACK_POST_MESSAGE, onBackAcceptAll)
}



// WEBPACK FOOTER //
// ./src/sagas/init-app.js